// MUI Icon imports - organized alphabetically
import AccountCircle from "@mui/icons-material/AccountCircle";
import Add from "@mui/icons-material/Add";
import ArrowBack from "@mui/icons-material/ArrowBack";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import ArrowForward from "@mui/icons-material/ArrowForward";
import ArrowUpward from "@mui/icons-material/ArrowUpward";
import Article from "@mui/icons-material/Article";
import Assignment from "@mui/icons-material/Assignment";
import AudioFile from "@mui/icons-material/AudioFile";
import Business from "@mui/icons-material/Business";
import Cancel from "@mui/icons-material/Cancel";
import Check from "@mui/icons-material/Check";
import CheckCircle from "@mui/icons-material/CheckCircle";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import Close from "@mui/icons-material/Close";
import CloudUpload from "@mui/icons-material/CloudUpload";
import ContentCopy from "@mui/icons-material/ContentCopy";
import Delete from "@mui/icons-material/Delete";
import Description from "@mui/icons-material/Description";
import Download from "@mui/icons-material/Download";
import Edit from "@mui/icons-material/Edit";
import Error from "@mui/icons-material/Error";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import FileDownload from "@mui/icons-material/FileDownload";
import FileUpload from "@mui/icons-material/FileUpload";
import FolderOpen from "@mui/icons-material/FolderOpen";
import FolderZip from "@mui/icons-material/FolderZip";
import FormatListBulleted from "@mui/icons-material/FormatListBulleted";
import GridOn from "@mui/icons-material/GridOn";
import Groups from "@mui/icons-material/Groups";
import Home from "@mui/icons-material/Home";
import Image from "@mui/icons-material/Image";
import Info from "@mui/icons-material/Info";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import List from "@mui/icons-material/List";
import ManageAccounts from "@mui/icons-material/ManageAccounts";
import ManageSearch from "@mui/icons-material/ManageSearch";
import Menu from "@mui/icons-material/Menu";
import MenuBook from "@mui/icons-material/MenuBook";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import MoreVert from "@mui/icons-material/MoreVert";
import Pause from "@mui/icons-material/Pause";
import Person from "@mui/icons-material/Person";
import PersonAdd from "@mui/icons-material/PersonAdd";
import PictureAsPdf from "@mui/icons-material/PictureAsPdf";
import PlayArrow from "@mui/icons-material/PlayArrow";
import Refresh from "@mui/icons-material/Refresh";
import Remove from "@mui/icons-material/Remove";
import Save from "@mui/icons-material/Save";
import Schedule from "@mui/icons-material/Schedule";
import Search from "@mui/icons-material/Search";
import Send from "@mui/icons-material/Send";
import Settings from "@mui/icons-material/Settings";
import Slideshow from "@mui/icons-material/Slideshow";
import Stop from "@mui/icons-material/Stop";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Warning from "@mui/icons-material/Warning";

/**
 * Mapping from FontAwesome icon names to MUI icon components
 * Usage: iconMapping['edit'] returns the Edit MUI icon component
 */
const iconMapping = {
    // Basic actions
    "edit": Edit,
    "pencil": Edit,
    "trash": Delete,
    "delete": Delete,
    "plus": Add,
    "add": Add,
    "minus": Remove,
    "remove": Remove,
    "times": Close,
    "close": Close,
    "xmark": Close,
    "check": Check,
    "save": Save,
    "copy": ContentCopy,

    // Navigation
    "arrow-right": ArrowForward,
    "arrow-left": ArrowBack,
    "arrow-up": ArrowUpward,
    "arrow-down": ArrowDownward,
    "chevron-left": ChevronLeft,
    "chevron-right": ChevronRight,
    "chevron-up": KeyboardArrowUp,
    "chevron-down": KeyboardArrowDown,
    "angle-up": ExpandLess,
    "angle-down": ExpandMore,
    "caret-up": KeyboardArrowUp,
    "caret-down": KeyboardArrowDown,

    // Search
    "search": Search,
    "magnifying-glass": Search,
    "magnifying-glass-chart": ManageSearch,

    // User icons
    "user": Person,
    "user-circle": AccountCircle,
    "user-tie": ManageAccounts,
    "user-group": Groups,
    "users": Groups,
    "user-tag": PersonAdd,
    "user-plus": PersonAdd,

    // Info/Status
    "info": Info,
    "info-circle": InfoOutlined,
    "circle-info": InfoOutlined,
    "exclamation-circle": Error,
    "circle-exclamation": Error,
    "warning": Warning,
    "triangle-exclamation": Warning,
    "circle-check": CheckCircle,
    "check-circle": CheckCircle,
    "circle-xmark": Cancel,
    "times-circle": Cancel,

    // Media controls
    "play": PlayArrow,
    "pause": Pause,
    "stop": Stop,

    // Files & Documents
    "file": InsertDriveFile,
    "file-alt": Article,
    "file-lines": Article,
    "file-pdf": PictureAsPdf,
    "file-word": Description,
    "file-excel": GridOn,
    "file-powerpoint": Slideshow,
    "file-image": Image,
    "file-zipper": FolderZip,
    "file-archive": FolderZip,
    "file-audio": AudioFile,
    "file-export": FileDownload,
    "file-import": FileUpload,
    "file-download": FileDownload,
    "file-upload": FileUpload,

    // Folders
    "folder": FolderOpen,
    "folder-open": FolderOpen,

    // Lists
    "list": List,
    "list-ul": FormatListBulleted,
    "bars": Menu,
    "clipboard-list": Assignment,
    "book-open": MenuBook,
    "book": MenuBook,

    // Other common icons
    "home": Home,
    "city": Business,
    "building": Business,
    "redo": Refresh,
    "refresh": Refresh,
    "sync": Refresh,
    "clock": Schedule,
    "ellipsis": MoreHoriz,
    "ellipsis-h": MoreHoriz,
    "ellipsis-v": MoreVert,
    "ellipsis-vertical": MoreVert,
    "cog": Settings,
    "gear": Settings,
    "eye": Visibility,
    "eye-slash": VisibilityOff,
    "cloud-upload": CloudUpload,
    "upload": CloudUpload,
    "download": Download,
    "paper-plane": Send,
    "send": Send,
};

/**
 * Get MUI icon component by FontAwesome icon name
 * @param {string} faName - FontAwesome icon name (without 'fa-' prefix)
 * @returns {React.ComponentType} MUI icon component or null if not found
 */
export const getMuiIcon = (faName) => {
    if (!faName) return null;
    // Remove 'fa-' prefix if present
    const cleanName = faName.replace(/^fa-/, '');
    return iconMapping[cleanName] || null;
};

/**
 * Size mapping from FontAwesome sizes to MUI fontSize values
 */
export const sizeMapping = {
    "xs": 12,
    "sm": 16,
    "": 20,    // default
    "lg": 24,
    "1x": 20,
    "2x": 32,
    "3x": 48,
    "5x": 80,
    "7x": 112,
    "10x": 160,
};

export default iconMapping;
